/**
 * Created by vladislav on 3/15/19
 */

const IceBlockMakerTileView = cc.Node.extend({
    ...BaseTileView,
    ctor: function (tile) {
        this._super(tile);

        this.setAnchorPoint(0.5, 0.5);

        this.initialize(tile);

        const animation = this.animation = new cleverapps.Spine(bundles.ice_block_maker.jsons.ice_block_maker_json);
        this.addChild(animation);
        animation.setAlignment(this.width / 2, this.height / 2);
        animation.setAnimation(0, "idle_2", true);

        tile.onStateChanged = this.changeState.bind(this);
        tile.onCellFreezed = this.onCellFreezed.bind(this);
    },

    changeState: function (state) {
        const idleName = state ? "idle_1" : "idle_2";
        const transitionName = state ? "transition_1" : "transition_2";
        this.animation.setAnimation(0, transitionName, false);
        this.animation.setCompleteListener(() => {
            this.animation.setCompleteListener();
            this.animation.setAnimation(0, idleName, true);
        });
    },
    
    onCellFreezed: function () {
        cleverapps.effects.fire(cleverapps.styles.IceBlockMakerTileView.growUpEffect);
    }
});

cleverapps.styles.IceBlockMakerTileView = {
    growUpEffect: "match3.element.grow"
};